import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { IoMdAddCircleOutline } from 'react-icons/io'
import { FaEdit, FaRegPlusSquare } from 'react-icons/fa'
import { unitProductsService } from '../../_services/unitProducts.service'
import AsyncSelect from 'react-select';
import ClientFormDialog from '../Clients/ClientFormDialog'
import { productsService } from '../../_services/products.service';


class AsyncProductSelectByNameAndCode extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
      selectedValue: '',
      keyword: '',
      formDialog: false,
      categoryId: undefined,
      brandId: undefined
    };
  }

  // componentWillMount() {
  //   this.getData();
  // }

  getData() {
    // var dto = {
    //   "page": 1,
    //   "pageSize": 10,
    //   "brandName": "",
    //   "categoryTypeIds": []
    // }
    // brandService.getAll(JSON.stringify(dto))
    //   .then((res) => {
    //     console.log(res.data)
    //     let data = res.data.result.map(elm => ({ "label": elm.name, "value": elm.id }))
    //     this.setState({ data: data, loading: false, isSubmitting: false });
    //   }).catch((error) => { console.log(error) });
  };

  getDataByCategoryAndBrand() {
    if (this.state.categoryId && this.state.brandId) {
      this.setState({ loading: true })
      productsService.getAllByCategoryAndBrand(this.state.categoryId, this.state.brandId)
        .then((res) => {
          // console.log(res.data);

          let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
          this.setState({ data: data, loading: false, isSubmitting: false });
        }).catch((error) => {
          this.setState({ loading: false })
          // console.log(error)
        });
    }
  };

  handleChange = e => {
    console.log(e);
    this.setState({ selectedValue: e.value }, () => {
      this.props.onChange(e.value, e.unitProduct, this.state.data);
    })
  }

  handleInputChange = (val) => {
    if (val !== undefined && val.length > 0) {
      this.setState({ keyword: val, data: [], loading: true, isSubmitting: false });
      var dto = {
        "keyword": val,
        "unitId": this.props.unitId,
      }


      unitProductsService.search(JSON.stringify(dto))
        .then((res) => {
          console.log(res.data);


          let data = res.data.map(elm => ({ "label": elm.name + " (" + elm.extraCode + ")", "value": elm.id, "unitProduct": elm.product }))

          // console.log(data);
          this.setState({ data: data, loading: false, isSubmitting: false }, () => {
            // if (this.props.defaultValue) {
            //   this.setState({selectedValue: this.props.defaultValue})
            // }
          });
        })
        .catch((error) => {
          // console.log(error);
          this.setState({ data: [], loading: false, isSubmitting: false })
        });
    }
  }

  componentWillReceiveProps(nextProps) {

    // if (nextProps.defualtData !== undefined && nextProps.defualtData !== this.state.data) {
    //   this.setState({ data: [nextProps.defualtData] })
    // }

    console.log(nextProps);

    if (nextProps.defualtValue !== undefined && nextProps.defualtValue !== this.state.selectedValue) {
      this.setState({ selectedValue: nextProps.defualtValue }, () => {
        if (nextProps.defualtData !== undefined) {
          this.setState({ data: nextProps.defualtData }, () => {
            // this.handleChange(nextProps.defualtData.filter(e => e.value === nextProps.defualtValue)[0]);
          })
        }
      })
    }

    if (nextProps.categoryId !== undefined && nextProps.categoryId !== this.state.categoryId) {
      this.setState({ categoryId: nextProps.categoryId }, () => {


        this.getDataByCategoryAndBrand()



      })
    }

    if (nextProps.brandId !== undefined && nextProps.brandId !== this.state.brandId) {
      this.setState({ brandId: nextProps.brandId }, () => {



        this.getDataByCategoryAndBrand()



      })
    }


    // if (nextProps.defualtData !== undefined) {
    //   this.setState({ data: nextProps.defualtData }, () => {
    //     if (nextProps.defualtValue !== undefined && nextProps.defualtValue !== this.state.selectedValue) {
    //       this.setState({ selectedValue: nextProps.defualtValue }, () => {
    //         // this.handleInputChange(nextProps.defualtData.name.charAt(0))
    //       })
    //     }
    //   })
    // }

  }

  render() {
    const customStyles = {
      control: (provided) => ({
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12',
        border: 'thin solid #e1e1e1 '
      }),
      menuList: (provided) => ({
        ...provided,
        direction: 'ltr'
      }),
      noOptionsMessage: (provided) => ({
        ...provided,
        fontSize: '12px'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
    }
    const { loading, data, value, keyword, selectedValue } = this.state;
    const { disabled, required, placeholder, tabIndex, type } = this.props;

    return (
      <>
        {/* <div className="client-select-container"> */}
        <AsyncSelect
          cacheOptions
          tabIndex={tabIndex}
          classNamePrefix="select"
          // loadOptions={this.loadOptions}
          // defaultOptions
          // menuIsOpen={true}
          placeholder={placeholder || ''}
          isDisabled={disabled}
          styles={customStyles}
          options={data}
          onInputChange={this.handleInputChange}
          className={required ? "select required" : "select"}
          value={data ? data.filter(e => e.value === selectedValue)[0] : ''}
          onChange={this.handleChange}
          noOptionsMessage={() => ((keyword.length > 0 && (!data || data.length === 0)) ? "نتیجه ای یافت نشد" : "نام و یا کد محصول را وارد نمایید")}
          loadingMessage={() => "در حال دریافت اطلاعات از سرور"}
          isLoading={loading}
        />
        {/* {selectedValue ?
            <a onClick={() => this.handleEditClient()}>
              <FaEdit size="24px" />
            </a>
            : ''}
          <a onClick={() => this.handleCreateClient()}>
            <FaRegPlusSquare size="22px" />
          </a> */}

        {/* </div> */}
        {/* <ClientFormDialog
          show={this.state.formDialog}
          clientId={selectedValue}
          handleModalHide={() => this.handleModalHide()}
          handleModalHideAndReload={() => this.handleModalHideAndReload()}
        /> */}
      </>
    );
  }
}
export default AsyncProductSelectByNameAndCode;
